import { useLocalStorage } from "../../sg-hooks/useLocalStorage";

export type UseOfflineStorageHook = (keyBase: string) => {
    getItem: <T = any> (key: string) => T | null;
    setItem: (key: string, data: any) => void;
    clearItem: (key: string) => any;
    clearStorage: () => void;
};


export const useOfflineStorage: UseOfflineStorageHook = (keyBase: string) => {

    const [keyList, setKeyList] = useLocalStorage<Array<string>>(`sg-core:${keyBase}`, []);

    const resolveKey = (key: string) => {
        return `${keyBase}:${key}`
    };

    const addKey = (key: string) => {
        //   setKeyList((list) => [...list, resolveKey(key)]);
    };

    const removeKey = (keyToRemove: string) => {
        //   setKeyList((list) =>
        //       list.filter((key) => key !== resolveKey(keyToRemove))
        //   );
    };

    const getItem = <T = any>(key: string): T | null => {
        try {
            const item = window.localStorage.getItem(resolveKey(key));
            addKey(key);
            return item ? JSON.parse(item) : null;
        } catch (error) {
            clearItem(key);
            // console.log(error);
            return null;
        }
    };

    const setItem = <T = any>(key: string, data: T) => {
        try {
            addKey(key);
            window.localStorage.setItem(resolveKey(key), JSON.stringify(data));
        } catch (error) {
            clearItem(key);
            console.log(error);
        }
    };

    const clearItem = (key: string) => {
        try {
            window.localStorage.removeItem(resolveKey(key));
            removeKey(key);
        } catch (error) {
            console.log(error);
        }
    };

    const clearStorage = () => {
        if (Array.isArray(keyList)) {

        }
        keyList.forEach((key) => {
            try {
                window.localStorage.removeItem(key);
                removeKey(key);
            } catch (error) {
                console.log(error);
            }
        });
        Object.entries(localStorage).map(x => x[0]).filter(x => x.indexOf(keyBase) > -1).map(x => localStorage.removeItem(x))
        setKeyList([]);
    };

    return {
        getItem,
        setItem,
        clearItem,
        clearStorage
    };
};
